import React from 'react';
import { ArticleCarousel, ArticleCompactInlineCard } from '@browsing/components';
import InView from 'react-intersection-observer';
import { trackSelectItem, trackViewItemList } from '@browsing/tracking';
import { NavigationSourceType } from '@browsing/utils';
import { Translate, TranslateScope } from '@pegasus/translation';
import { useRecommendations } from './hooks/use-recommendations';
var renderArticle = function (article, index) {
    var handleOnClick = function () {
        trackSelectItem({
            element: 'popular_near_you_carousel',
            itemListName: 'popular_near_you_carousel',
            context: 'popular_near_you_carousel',
            item: article,
        }, {
            customMapper: function () { return ({ index: index }); },
        });
    };
    return (React.createElement(ArticleCompactInlineCard, { key: article.sku, brand: article.brand, campaignIdentifier: article.campaignIdentifier, handleOnClick: handleOnClick, media: article.media, nameCategoryTag: article.nameCategoryTag, nameColor: "", nameShop: "", navigationSource: NavigationSourceType.Highligts, price: article.price, sku: article.sku, specialPrice: article.specialPrice }));
};
export var HighlightsCarousel = function (_a) {
    var gender = _a.gender, textTitle = _a.textTitle;
    var highlights = useRecommendations(gender)[0];
    var onInView = function (inView) {
        if (inView && highlights.length > 0) {
            trackViewItemList({
                items: highlights,
                element: 'popular_near_you_carousel',
                context: 'popular_near_you_carousel',
                itemListName: 'popular_near_you_carousel',
            });
        }
    };
    if (highlights.length <= 0) {
        return null;
    }
    return (React.createElement(InView, { as: "div", onChange: onInView, triggerOnce: true, "data-testid": "mylounge-recommendation-wrapper" },
        React.createElement(TranslateScope, { path: "article" },
            React.createElement(ArticleCarousel, { id: "highlights-carousel-headline", title: React.createElement(TranslateScope, null,
                    React.createElement(Translate, { message: "highlights.carouselTitle" })), textTitle: textTitle }, highlights.map(renderArticle)))));
};
